import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button, Container, Card } from "react-bootstrap";
import { getLead, deleteLead, } from "../../store/slices/leads";
import DeleteModal from "./deletepopup";
import { useDispatch, useSelector } from "react-redux";
import { FaEdit, FaTrash, FaEye, FaWhatsapp } from "react-icons/fa";

export default function Leads() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const itemsPerPage = 25;

  const {
    leadList = [],
    loading,
    pages = 1,
  } = useSelector((state) => state.lead);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search.trim());
      setCurrentPage(1);
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    const params = {
      page: currentPage,
      limit: itemsPerPage,
    };

    if (debouncedSearch) {
      params.search = debouncedSearch;
    }

    dispatch(getLead(params));
  }, [dispatch, currentPage, debouncedSearch]);

  const [showDelete, setShowDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [deleteStatus, setDeleteStatus] = useState("confirm");
  const totalPages = pages;
  const handleWhatsApp = (phone) => {
    if (!phone) return;

    // Remove +, spaces, dashes etc.
    const formattedPhone = phone.replace(/\D/g, "");

    window.open(`https://wa.me/${formattedPhone}`, "_blank");
  };

  // handledelete
  const handleConfirmDelete = async () => {
    try {
      setDeleteStatus("loading");

      await dispatch(deleteLead(selectedId)).unwrap();

      setDeleteStatus("success");
      dispatch(
        getLead({
          page: currentPage,
          limit: itemsPerPage,
          ...(debouncedSearch && { search: debouncedSearch }),
        })
      );
      setTimeout(() => {
        setShowDelete(false);
        setDeleteStatus("confirm");
      }, 1500);
    } catch (error) {
      setDeleteStatus("confirm");
    }
  };


  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">|</span>

          <span
            className="breadcrumb-link inactive"
            onClick={() => navigate("/admin/lead")}
          >
            Lead
          </span>
        </div>

        <button
          className="add-outlet-btn"
          onClick={() => navigate("/admin/addlead")}
        >
          + Add Lead
        </button>
      </div>
      <Container fluid>
        <Card className="table-border">
          <Card.Body>
            <div className="guests-table-wrapper common-table-wrapper">
              <div className="d-flex gap-2 mb-3 mt-2 ms-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search lead..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={{ maxWidth: "300px" }}
                />

                <button
                  className="cancel-btn"
                  onClick={() => {
                    setSearch("");
                    setDebouncedSearch("");
                    setCurrentPage(1);
                  }}
                >
                  Reset
                </button>
              </div>
              <table className="table guests-table common-table align-middle">
                <thead>
                  <tr>
                    <th className="text-center">#</th>
                    <th className="text-center">Name</th>
                    <th className="text-center">Email</th>
                    <th className="text-center">Mobile Number</th>
                    <th className="text-center">City</th>
                    <th className="text-center">Source</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    [...Array(6)].map((_, index) => (
                      <tr key={index}>
                        <td className="text-center">
                          <div className="skeleton skeleton-text small"></div>
                        </td>

                        <td className="text-center">
                          <div className="skeleton skeleton-text"></div>
                        </td>

                        <td className="text-center">
                          <div className="skeleton skeleton-text"></div>
                        </td>

                        <td className="text-center">
                          <div className="skeleton skeleton-text"></div>
                        </td>

                        <td className="text-center">
                          <div className="skeleton skeleton-text"></div>
                        </td>

                        <td className="text-center">
                          <div className="skeleton skeleton-text"></div>
                        </td>

                        <td className="text-center">
                          <div className="action-btn-group d-flex justify-content-center gap-2">
                            <div className="skeleton skeleton-btn"></div>
                            <div className="skeleton skeleton-btn"></div>
                            <div className="skeleton skeleton-btn"></div>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : leadList?.length > 0 ? (
                    leadList.map((lead, index) => (
                      <tr key={lead._id}>
                        <td className="text-center">
                          {(currentPage - 1) * itemsPerPage + index + 1}
                        </td>

                        <td className="text-center" style={{ maxWidth: "100px" }}>{lead.name}</td>

                        <td className="text-center">{lead.email}</td>

                        <td className="text-center">{lead.phone}</td>
                        <td className="text-center">{lead.city}</td>
                        <td className="text-center">{lead.source}</td>

                        <td className="text-center">
                          <div className="action-btn-group d-flex justify-content-center gap-2">
                            <button
                              className="action-btn edit-btn"
                              onClick={() => handleWhatsApp(lead.phone)}
                            >
                              <FaWhatsapp size={14} />
                            </button>
                            <button
                              onClick={() =>
                                navigate(`/admin/lead-details/${lead._id}`)
                              }
                              className="action-btn edit-btn"
                            >
                              <FaEye size={14} />
                            </button>

                            <button
                              onClick={() =>
                                navigate(`/admin/editlead/${lead._id}`)
                              }
                              className="action-btn edit-btn"
                            >
                              <FaEdit size={14} />
                            </button>

                            <button
                              className="action-btn delete-btn"
                              onClick={() => {
                                setSelectedId(lead._id);
                                setShowDelete(true);
                              }}
                            >
                              <FaTrash size={14} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center text-muted py-4">
                        No Leads Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {!loading && totalPages > 1 && (
              <div className="d-flex justify-content-center align-items-center gap-2 mt-4 flex-wrap">

                <Button
                  variant="light"
                  disabled={currentPage === 1}
                  onClick={() =>
                    setCurrentPage(currentPage - 1)
                  }
                >
                  ‹
                </Button>


                {Array.from(
                  { length: totalPages },
                  (_, i) => i + 1
                )
                  .filter((page) => {

                    return (
                      page === 1 ||
                      page === totalPages ||
                      Math.abs(page - currentPage) <= 1
                    );

                  })
                  .map((page, index, arr) => {

                    const prevPage = arr[index - 1];

                    return (
                      <div
                        key={page}
                        className="d-flex align-items-center gap-2"
                      >

                        {/* DOTS */}
                        {
                          prevPage &&
                          page - prevPage > 1 && (
                            <span>...</span>
                          )
                        }

                        <Button
                          variant={
                            currentPage === page
                              ? "dark"
                              : "light"
                          }
                          onClick={() =>
                            setCurrentPage(page)
                          }
                        >
                          {page}
                        </Button>

                      </div>
                    );
                  })}

                {/* NEXT */}

                <Button
                  variant="light"
                  disabled={
                    currentPage === totalPages
                  }
                  onClick={() =>
                    setCurrentPage(currentPage + 1)
                  }
                >
                  ›
                </Button>

              </div>
            )}
          </Card.Body>
        </Card>
      </Container >
      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onConfirm={handleConfirmDelete}
        status={deleteStatus}
      />
    </>
  );
}
